import React from 'react';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  type?: 'danger' | 'warning' | 'info';
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  type = 'warning',
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return '🗑️';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '⚠️';
    }
  };

  const getColor = () => {
    switch (type) {
      case 'danger':
        return '#dc3545';
      case 'warning':
        return '#ffc107';
      case 'info':
        return '#0dcaf0';
      default:
        return '#ffc107';
    }
  };

  return (
    <div 
      className="modal-overlay" 
      onClick={onCancel}
      style={{ zIndex: 1000 }}
    >
      <div 
        className="modal" 
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '450px' }}
      >
        <div className="modal-header" style={{ borderBottom: 'none', paddingBottom: '0' }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px',
            width: '100%'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              background: `${getColor()}20`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '26px',
              flexShrink: 0
            }}>
              {getIcon()}
            </div>
            <h3 className="modal-title" style={{ fontSize: '22px', flex: 1, margin: 0 }}>
              {title}
            </h3>
          </div>
          <button 
            className="modal-close" 
            onClick={onCancel}
            style={{ 
              position: 'absolute',
              right: '20px',
              top: '20px'
            }}
          >
            ×
          </button>
        </div>

        <div className="modal-body" style={{ paddingTop: '16px', paddingLeft: '60px' }}>
          <p className="modal-message">
            {message}
          </p>
        </div>

        <div className="modal-footer" style={{ gap: '12px', paddingTop: '24px' }}>
          <button 
            type="button" 
            className="btn-cancel" 
            onClick={onCancel}
            style={{
              padding: '10px 24px',
              fontSize: '17px',
              fontWeight: '500'
            }}
          >
            {cancelText}
          </button>
          <button 
            type="button" 
            className="btn-submit" 
            onClick={onConfirm}
            style={{
              padding: '10px 24px',
              fontSize: '17px',
              fontWeight: '500',
              background: type === 'danger' ? '#dc3545' : type === 'info' ? '#0dcaf0' : '#ffc107',
              borderColor: type === 'danger' ? '#dc3545' : type === 'info' ? '#0dcaf0' : '#ffc107',
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;

